import React, { useState } from 'react';
import { DatabaseIcon, TrendingUpIcon, FileTextIcon, LayoutDashboardIcon } from 'lucide-react';
export function Tools() {
  const [activeDemo, setActiveDemo] = useState<string>('invoice');
  const features = [{
    title: 'En KONTAXES, trabajamos con Odoo',
    description: 'Una potente plataforma de gestión empresarial que nos permite llevar cada contabilidad con precisión, eficiencia y transparencia.',
    icon: DatabaseIcon
  }, {
    title: 'Información confiable y actualizada',
    description: 'Esto nos permite ofrecerte información financiera confiable, actualizada y accesible, facilitando la toma de decisiones estratégicas para tu negocio.',
    icon: TrendingUpIcon
  }, {
    title: 'Enfócate en crecer',
    description: 'Así, tú te concentras en hacer crecer tu empresa, y nosotros nos encargamos de que tus números siempre estén al día.',
    icon: FileTextIcon
  }];
  const demos = [{
    id: 'invoice',
    label: 'Ingresar Factura',
    icon: FileTextIcon
  }, {
    id: 'reconciliation',
    label: 'Conciliación Bancaria',
    icon: DatabaseIcon
  }, {
    id: 'reports',
    label: 'Reportería',
    icon: TrendingUpIcon
  }, {
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }];
  return <section id="herramientas" className="py-20 bg-white dark:bg-gray-900" data-id="element-305">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
        <div className="text-center mb-16" data-id="element-307">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-308">
            Herramientas Odoo
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400" data-id="element-309">
            Tecnología de clase mundial para tu contabilidad
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-310">
          {features.map((feature, index) => <div key={index} className="group bg-gradient-to-br from-purple-50 to-white dark:from-gray-800 dark:to-gray-900 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer" data-id="element-311">
              <feature.icon className="w-12 h-12 text-purple-600 dark:text-purple-400 mb-4 group-hover:scale-110 transition-transform" data-id="element-312" />
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3" data-id="element-313">
                {feature.title}
              </h3>
              <p className="text-gray-700 dark:text-gray-300" data-id="element-314">
                {feature.description}
              </p>
            </div>)}
        </div>

        {/* Demo Selector */}
        <div className="mb-8" data-id="element-315">
          <div className="flex flex-wrap justify-center gap-4" data-id="element-316">
            {demos.map(demo => <button key={demo.id} onClick={() => setActiveDemo(demo.id)} className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-semibold transition-all ${activeDemo === demo.id ? 'bg-purple-600 text-white shadow-lg scale-105' : 'bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-purple-100 dark:hover:bg-purple-900/30'}`} data-id="element-317">
                <demo.icon size={20} data-id="element-318" />
                <span data-id="element-319">{demo.label}</span>
              </button>)}
          </div>
        </div>

        {/* Demo Display */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 border-4 border-purple-200 dark:border-purple-900" data-id="element-320">
          {activeDemo === 'invoice' && <div className="space-y-6" data-id="element-321">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-322">
                Módulo de Contabilidad - Ingresar Factura
              </h3>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-323">
                <div data-id="element-324">
                  <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" data-id="element-325">
                    Proveedor
                  </label>
                  <input type="text" placeholder="Seleccionar proveedor..." className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white" readOnly data-id="element-326" />
                </div>
                <div data-id="element-327">
                  <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" data-id="element-328">
                    Fecha de Factura
                  </label>
                  <input type="date" className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white" readOnly data-id="element-329" />
                </div>
                <div data-id="element-330">
                  <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" data-id="element-331">
                    Número de Factura
                  </label>
                  <input type="text" placeholder="FAC-001" className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white" readOnly data-id="element-332" />
                </div>
                <div data-id="element-333">
                  <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" data-id="element-334">
                    Monto Total
                  </label>
                  <input type="text" placeholder="Q 1,000.00" className="w-full px-4 py-3 rounded-lg border-2 border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-900 dark:text-white" readOnly data-id="element-335" />
                </div>
              </div>
              <div className="pt-4" data-id="element-336">
                <button className="px-6 py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition-all" data-id="element-337">
                  Guardar Factura
                </button>
              </div>
            </div>}

          {activeDemo === 'reconciliation' && <div className="space-y-6" data-id="element-338">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-339">
                Conciliación Bancaria
              </h3>
              <div className="overflow-x-auto" data-id="element-340">
                <table className="w-full" data-id="element-341">
                  <thead className="bg-purple-100 dark:bg-purple-900/30" data-id="element-342">
                    <tr data-id="element-343">
                      <th className="px-4 py-3 text-left text-gray-900 dark:text-white" data-id="element-344">
                        Fecha
                      </th>
                      <th className="px-4 py-3 text-left text-gray-900 dark:text-white" data-id="element-345">
                        Descripción
                      </th>
                      <th className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-346">
                        Débito
                      </th>
                      <th className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-347">
                        Crédito
                      </th>
                      <th className="px-4 py-3 text-center text-gray-900 dark:text-white" data-id="element-348">
                        Estado
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-349">
                    <tr data-id="element-350">
                      <td className="px-4 py-3 text-gray-900 dark:text-white" data-id="element-351">
                        15/01/2024
                      </td>
                      <td className="px-4 py-3 text-gray-900 dark:text-white" data-id="element-352">
                        Pago Cliente A
                      </td>
                      <td className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-353">
                        Q 5,000.00
                      </td>
                      <td className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-354">
                        -
                      </td>
                      <td className="px-4 py-3 text-center" data-id="element-355">
                        <span className="px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 rounded-full text-sm" data-id="element-356">
                          Conciliado
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-357">
                      <td className="px-4 py-3 text-gray-900 dark:text-white" data-id="element-358">
                        16/01/2024
                      </td>
                      <td className="px-4 py-3 text-gray-900 dark:text-white" data-id="element-359">
                        Pago Proveedor B
                      </td>
                      <td className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-360">
                        -
                      </td>
                      <td className="px-4 py-3 text-right text-gray-900 dark:text-white" data-id="element-361">
                        Q 2,500.00
                      </td>
                      <td className="px-4 py-3 text-center" data-id="element-362">
                        <span className="px-3 py-1 bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200 rounded-full text-sm" data-id="element-363">
                          Pendiente
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>}

          {activeDemo === 'reports' && <div className="space-y-6" data-id="element-364">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-365">
                Generación de Reportes
              </h3>
              <div className="grid md:grid-cols-2 gap-6" data-id="element-366">
                <div className="p-6 bg-purple-50 dark:bg-purple-900/20 rounded-lg hover:shadow-lg transition-all cursor-pointer" data-id="element-367">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-2" data-id="element-368">
                    Balance General
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-369">
                    Estado de situación financiera al cierre del período
                  </p>
                  <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all" data-id="element-370">
                    Generar Reporte
                  </button>
                </div>
                <div className="p-6 bg-purple-50 dark:bg-purple-900/20 rounded-lg hover:shadow-lg transition-all cursor-pointer" data-id="element-371">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-2" data-id="element-372">
                    Estado de Resultados
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-373">
                    Ingresos, costos y utilidades del período
                  </p>
                  <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all" data-id="element-374">
                    Generar Reporte
                  </button>
                </div>
                <div className="p-6 bg-purple-50 dark:bg-purple-900/20 rounded-lg hover:shadow-lg transition-all cursor-pointer" data-id="element-375">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-2" data-id="element-376">
                    Libro Diario
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-377">
                    Registro cronológico de todas las operaciones
                  </p>
                  <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all" data-id="element-378">
                    Generar Reporte
                  </button>
                </div>
                <div className="p-6 bg-purple-50 dark:bg-purple-900/20 rounded-lg hover:shadow-lg transition-all cursor-pointer" data-id="element-379">
                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-2" data-id="element-380">
                    Libro Mayor
                  </h4>
                  <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-381">
                    Movimientos por cuenta contable
                  </p>
                  <button className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-all" data-id="element-382">
                    Generar Reporte
                  </button>
                </div>
              </div>
            </div>}

          {activeDemo === 'dashboard' && <div className="space-y-6" data-id="element-383">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-6" data-id="element-384">
                Dashboard - Tablero de Control
              </h3>
              <div className="grid md:grid-cols-3 gap-6" data-id="element-385">
                <div className="p-6 bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 rounded-lg" data-id="element-386">
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-387">
                    Ingresos del Mes
                  </p>
                  <p className="text-3xl font-bold text-blue-600 dark:text-blue-400" data-id="element-388">
                    Q 45,230
                  </p>
                  <p className="text-sm text-green-600 dark:text-green-400 mt-2" data-id="element-389">
                    ↑ 12% vs mes anterior
                  </p>
                </div>
                <div className="p-6 bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/30 rounded-lg" data-id="element-390">
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-391">
                    Gastos del Mes
                  </p>
                  <p className="text-3xl font-bold text-green-600 dark:text-green-400" data-id="element-392">
                    Q 28,450
                  </p>
                  <p className="text-sm text-red-600 dark:text-red-400 mt-2" data-id="element-393">
                    ↑ 5% vs mes anterior
                  </p>
                </div>
                <div className="p-6 bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30 rounded-lg" data-id="element-394">
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-2" data-id="element-395">
                    Utilidad Neta
                  </p>
                  <p className="text-3xl font-bold text-purple-600 dark:text-purple-400" data-id="element-396">
                    Q 16,780
                  </p>
                  <p className="text-sm text-green-600 dark:text-green-400 mt-2" data-id="element-397">
                    ↑ 23% vs mes anterior
                  </p>
                </div>
              </div>
              <div className="mt-8 p-6 bg-gray-50 dark:bg-gray-800 rounded-lg" data-id="element-398">
                <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4" data-id="element-399">
                  Gráfico de Ingresos vs Gastos
                </h4>
                <div className="h-48 flex items-end justify-around space-x-4" data-id="element-400">
                  {[65, 80, 75, 90, 85, 95].map((height, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-401">
                      <div className="w-full bg-gradient-to-t from-purple-600 to-purple-400 rounded-t-lg transition-all hover:opacity-80" style={{
                  height: `${height}%`
                }} data-id="element-402"></div>
                      <span className="text-xs text-gray-600 dark:text-gray-400 mt-2" data-id="element-403">
                        {['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun'][index]}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>}
        </div>
      </div>
    </section>;
}